import { string } from "prop-types";
import styled from "styled-components/macro";
import { rem } from "polished";

import { colors, fonts } from "../../../styles/Styles.variables";

import { BREAKPOINT_WRAPPER } from "../../../constants";
import Raw from "../../../styles/components/Raw";

import testimonialBg from "../../../assets/img/backgrounds/testimonial-bg.png";

const LocationTestimonial = ({ quote, source }) => {
  return (
    <Testimonial>
      <Raw html={quote} />
      {!!source && <footer>{source}</footer>}
    </Testimonial>
  );
};

LocationTestimonial.propTypes = {
  quote: string.isRequired,
  source: string,
};

const quoteLeft = `data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2035%2033%22%3E%3Cpath%20fill%3D%22${encodeURIComponent(
  colors.yellow
)}%22%20d%3D%22M6.844%2C18.531%20C6.976%2C14.707%207.612%2C11.797%208.755%2C9.797%20C9.898%2C7.797%2011.677%2C6.293%2014.095%2C5.281%20L11.194%2C0.667%20C7.195%2C2.469%204.273%2C5.128%202.427%2C8.643%20C1.020%2C11.280%200.318%2C15.543%200.318%2C21.431%20L0.318%2C32.308%20L13.040%2C32.308%20L13.040%2C18.531%20L6.844%2C18.531%20ZM27.278%2C18.531%20C27.410%2C14.707%2028.047%2C11.797%2029.190%2C9.797%20C30.332%2C7.797%2032.112%2C6.293%2034.529%2C5.281%20L31.629%2C0.667%20C27.630%2C2.469%2024.708%2C5.128%2022.862%2C8.643%20C21.455%2C11.280%2020.752%2C15.543%2020.752%2C21.431%20L20.752%2C32.308%20L33.475%2C32.308%20L33.475%2C18.531%20L27.278%2C18.531%20Z%22%2F%3E%3C%2Fsvg%3E`;

const quoteRight = `data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2035%2032%22%3E%3Cpath%20fill%3D%22${encodeURIComponent(
  colors.yellow
)}%22%20d%3D%22M7.778%2C14.103%20C7.646%2C17.751%206.997%2C20.619%205.833%2C22.705%20C4.668%2C24.793%202.900%2C26.320%200.527%2C27.287%20L3.427%2C31.967%20C7.426%2C30.165%2010.370%2C27.484%2012.260%2C23.925%20C13.622%2C21.332%2014.304%2C17.092%2014.304%2C11.203%20L14.304%2C0.326%20L1.582%2C0.326%20L1.582%2C14.103%20L7.778%2C14.103%20ZM28.212%2C14.103%20C28.081%2C17.751%2027.432%2C20.619%2026.268%2C22.705%20C25.103%2C24.793%2023.335%2C26.320%2020.961%2C27.287%20L23.862%2C31.967%20C27.860%2C30.165%2030.805%2C27.484%2032.695%2C23.925%20C34.056%2C21.332%2034.738%2C17.092%2034.738%2C11.203%20L34.738%2C0.326%20L22.016%2C0.326%20L22.016%2C14.103%20L28.212%2C14.103%20Z%22%2F%3E%3C%2Fsvg%3E`;

const Testimonial = styled.blockquote`
  background-color: ${colors.gray800};
  background-image: url(${testimonialBg});
  background-position: center;
  background-repeat: repeat;
  margin: 0 0 ${rem("20px")};
  padding: ${rem("48px")} ${rem("26px")};
  position: relative;
  text-align: center;

  &:before,
  &:after {
    background-position: center;
    background-repeat: no-repeat;
    display: block;
    color: ${colors.yellow};
    content: "";
    font-size: ${rem("135px")};
    line-height: 1;
    position: absolute;
    user-select: none;
  }

  &:before {
    background-image: url(${quoteLeft});
    height: ${rem("33px")};
    left: ${rem("7px")};
    top: ${rem("5px")};
    width: ${rem("35px")};
  }

  &:after {
    background-image: url(${quoteRight});
    bottom: ${rem("5px")};
    height: ${rem("32px")};
    right: ${rem("7px")};
    width: ${rem("35px")};
  }

  > div {
    color: ${colors.white};
    font-size: ${rem("20px")};
    font-weight: ${fonts.weights.bold};
    line-height: 1.4;

    > :last-child {
      margin-bottom: 0 !important;
    }
  }

  footer {
    color: ${colors.yellow};
    padding-top: ${rem("14px")};
  }

  @media ${BREAKPOINT_WRAPPER} {
    margin-bottom: ${rem("42px")};
    padding: ${rem("45px")} ${rem("94px")} ${rem("46px")};

    &:before {
      left: ${rem("15px")};
      top: ${rem("16px")};
    }

    &:after {
      bottom: ${rem("20px")};
      right: ${rem("15px")};
    }

    > div {
      font-size: ${rem("22px")};
    }

    footer {
      padding-top: ${rem("20px")};
    }
  }
`;

export default LocationTestimonial;
